import { yupResolver } from "@hookform/resolvers/yup";
import { Fragment, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { queryCounterDetails } from "src/services/counter-api";
import * as yup from "yup";
import Button from "../../components/Button";
import SmartForm from "../../components/SmartForm";
import { RootState } from "../../context/store";
import { useToast } from "src/hooks/useToast";
import { updateUINRequest } from "../../services/cda-api";

interface IndphUinReqStatusForm {
  masterUINDetails: any;
  companyUINDetails: any;
  actionType: string;
  reqId: number | string;
  onSuccess?: any;
}

const IndphUinReqStatusForm = ({ masterUINDetails, companyUINDetails, actionType, reqId, onSuccess }: IndphUinReqStatusForm) => {
  const { selectedData } = useSelector((state: RootState) => state.cra);
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const validationSchema = yup.object().shape({
    remarks: yup.string().when([], {
      is: () => actionType === "reject",
      then: (schema) => schema.required("Remarks are required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    ...(actionType === "approve" && {
      assc_counterhdr_id: yup.object().required("Counter name is required"),
    }),
  });

  async function handleFormSubmission(formData: any) {
    setLoading(true);

    const record = {
      indph_uln_validation: reqId,
      status: actionType == "approve" ? "approved" : "rejected",
      counterffdivision_lnk_id: masterUINDetails?.counterffdivision_lnk_id,
      assc_counterhdr_id: formData?.assc_counterhdr_id?.counter_id,
      Associated_Counter_Code: formData?.assc_counterhdr_id?.counter_code,
      Associated_Location_Code: formData?.assc_counterhdr_id?.location_code,
      uin_code: companyUINDetails?.Counter_UIN,
      company_alternate_uin: companyUINDetails?.Counter_AlternateUIN,
      remarks: formData?.remarks,
    };

    try {
      const res = await updateUINRequest(record);

      if (res?.status !== 200) throw new Error(res?.data?.message);
      setTimeout(() => {
        setLoading(false);
        toast({
          variant: "default",
          description: "UIN Request updated successfully",
        });
        onSuccess();
      }, 1000);
    } catch (error: any) {
      setLoading(false);
      console.log(error, "error");
      toast({
        description: error?.message || "Failed to update UIN request",
        variant: "destructive",
      });
    }
  }

  const queryAssoDoctorPromise = async (text: string) => {
    let backendParams = "";
    const companyId = masterUINDetails?.company_code;
    if (/^dr\d+/i.test(text)) {
      backendParams = `?linktype_id=1,2,5&perPage=75&page=0&counter_code=${
        text.toUpperCase().substring(0, 2) + text.substring(2)
      }&company_id=${companyId}`;
    } else {
      backendParams = `?linktype_id=1,2,5&perPage=75&page=0&name=${text}&company_id=${companyId}`;
    }

    const response = await queryCounterDetails(backendParams);

    const transformedAsyncList: any[] = [];
    response?.data?.data?.forEach((counter: any) => {
      counter?.counter_location?.forEach((counterLocation: any) => {
        if (
          counter?.active_status === "Y" &&
          counterLocation?.drph_lnk_type?.dr_ph_lnk_code !== "INDPH-NT" &&
          counterLocation?.location_code &&
          counter?.counter_id !== selectedData?.counter_id
        )
          transformedAsyncList.push({
            counter_name: counter?.counter_name,
            counter_id: counter?.counter_id,
            counter_code: counter?.counter_code,
            location_code: counterLocation?.location_code,
            location_name: counterLocation?.location_name,
            city_name: counterLocation?.city_code?.city_name,
            state_name: counterLocation?.city_code?.district_code?.state_code?.state_name,
          });
      });
    });

    return Promise.resolve(transformedAsyncList);
  };

  // Form instance
  const smartFormInstance = useForm<any>({
    resolver: yupResolver(validationSchema),
    mode: "onTouched",
    defaultValues: structuredClone({}),
  });

  return (
    <SmartForm formInstance={smartFormInstance} schema={validationSchema} isControlled={false} defaultValues={{}} onFormSubmit={handleFormSubmission}>
      <section className="flex flex-col gap-4 px-5 py-5 w-100">
        {actionType === "approve" && (
          <Fragment>
            <SmartForm.Autocomplete
              className=""
              placeholder="Select Associated doctor"
              fieldName="assc_counterhdr_id"
              label="Associated doctor name"
              suggestionList={[]}
              asyncListFunction={queryAssoDoctorPromise}
              uniqueKey="counter_code"
              displayKey="counter_name"
              additionalDisplayKeySearch={true}
              tertiaryDisplayKey="location_name"
              additionalfield="counter_code"
              isAsyncQuery={true}
            />
          </Fragment>
        )}

        <SmartForm.Input type="text" className="" placeholder="Type comment here..." fieldName="remarks" label="Remarks" />
      </section>
      <footer className="border border-t-[1px] flex justify-end px-5 py-3 gap-3 rounded-bl-2xl rounded-br-2xl">
        <Button className="border">Cancel</Button>
        <Button loaderSize="small" isLoading={loading} type="submit" className="text-white bg-[#586AF5]">
          Proceed
        </Button>
      </footer>
    </SmartForm>
  );
};

export default IndphUinReqStatusForm;
